import Relay from 'react-relay';

export default class GitPullTodayMutation extends Relay.Mutation {
    static propTypes = {};

    getMutation() {
        return Relay.QL`mutation {runGitPullTodayJob}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RunGitPullTodayJobPayload {
                success,
                message,
                jobName,
                jobStatus,
                completed,
                trackedJobRealId,
                trackedJobOrganisationId
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            waitForCompletion: this.props.waitForCompletion,
            timeoutSeconds: this.props.timeoutSeconds,
            checkOnly: this.props.checkOnly,
            jobName: this.props.jobName,
        };
    }
}
